import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot} from '@angular/router';
import {PageDataService} from '../services/page-data.service';
import {AuthService} from '../services/auth.service';
import {UrlConstants} from '../../shared/utils/url-constants';

@Injectable({
  providedIn: 'root'
})
export class PageDataGuard implements CanActivate {

  constructor(private pageDataService: PageDataService,
              private authService: AuthService) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (next.data) {
      this.pageDataService.showHeader$.next(next.data.showHeader !== false);
      this.pageDataService.showSidenav$.next(next.data.showSidenav !== false && this.authService.isLoggedIn());
      
      let showFooter = next.data.showFooter !== false;
      const isPrivacyTermsOrSupport = state.url.includes(UrlConstants.TERMS_OF_USE) || 
                                      state.url.includes(UrlConstants.PRIVACY_POLICY) || 
                                      state.url.includes(UrlConstants.CONTACT);
      if (isPrivacyTermsOrSupport && !this.authService.isLoggedIn()) {
        showFooter = false;
      }
      this.pageDataService.showFooter$.next(showFooter);
    }

    return true;
  }
}
